import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {EventConfigProvider} from "../../classes/EventConfigProvider";

@Component({
  selector: 'app-events-list-select',
  templateUrl: './events-list-select.component.html',
  styleUrls: ['./events-list-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventsListSelectComponent implements OnInit {

  constructor() { }

  public currentEventName;
  public eventsList = {};

  ngOnInit() {
    for (let event_id in window['EVENT_LIST']){
      if(!window['EVENT_LIST'].hasOwnProperty(event_id)){
        continue;
      }
      let item = window['EVENT_LIST'][event_id];
      if (event_id != window['EVENT_ID']){
        this.eventsList[event_id] = item;
      }
      else{
        this.currentEventName = item.name;
      }
    }
  }

  redirectToNewEvent(form){
    if (form.form.controls.current_event.value){
      location.href = form.form.controls.current_event.value;
    }
  }

}
